export default () => {
    const buttons = document.querySelectorAll('.committees-departments-cards__more-btn');

    if (buttons.length < 1) {
        return;
    }

    const displayHiddenCommites = (e) => {
        const {target} = e;
        const buttonWrapper = target.closest('.committees-departments-cards__more');

        const wrapper = target.closest('.committees-departments-wrapper');
        const hiddenCommittees = wrapper?.querySelectorAll('.tiles-grid__item--disabled');
        
        buttonWrapper?.remove();
        hiddenCommittees?.forEach(committee => committee.classList.remove('tiles-grid__item--disabled'));
    }

    buttons.forEach(button => button.addEventListener('click', displayHiddenCommites));
}
